import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Fund Family API
 */
class FundFamilyApi extends ApiBase {
  /**
   * Check if fund family ID already exists
   * @param {*} fundFamilyId
   */
  async checkIdExists(fundFamilyId) {
    const request = {
      url: `${this.API_URL}/fundfamily?id=${fundFamilyId}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return status === 200 || status === 403 || status === 404;
      }
    };

    const response = await axios.request(request);

    if (response.status === 200 || response.status === 403) {
      return true;
    } else if (response.status === 404) {
      return false;
    }
  }

  async getAll() {
    const request = {
      url: `${this.API_URL}/fundfamilies?orderBy=name&orderDirection=ASC`,
      method: 'GET',
      headers: this.getHeaders()
    };

    const response = await axios.request(request);
    return response.data;
  }

  async linkFundsToFundFamily(fundFamilyId, fundIds) {
    const request = {
      url: `${this.API_URL}/fundfamily/fundRelationship?fundFamilyId=${fundFamilyId}`,
      method: 'POST',
      headers: this.getHeaders(),
      data: fundIds
    };

    const response = await axios.request(request);
    return response.data;
  }

  async unlinkFundsFromFundFamily(fundFamilyId, fundIds) {
    const request = {
      url: `${this.API_URL}/fundfamily/fundRelationship?fundFamilyId=${fundFamilyId}`,
      method: 'DELETE',
      headers: this.getHeaders(),
      data: fundIds
    };

    const response = await axios.request(request);
    return response.data;
  }
}

export default new FundFamilyApi();
